import { setInitialValues as setInitialValuesForPaymentMethods } from '../../ducks/paymentMethods.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';

// ================ Action types ================ //

// ================ Reducer ================ //

/** @type {import('../../../types/vansite').VanSite.State.PaymentMethodsPage} */
const initialState = {};

export default function payoutMethodsPageReducer(state = initialState, action = {}) {
  const { type } = action;
  switch (type) {
    default:
      return state;
  }
}

// ================ Action creators ================ //

// ================ Thunks ================ //

export const loadData = () => (dispatch) => {
  dispatch(setInitialValuesForPaymentMethods());
  return Promise.resolve(dispatch(fetchCurrentUser()));
};
